import React from "react"

import { styled } from "@cirrus/ui-kit/src"

import { ButtonContainer } from "@cirrus/ui-kit/src/components/atoms/button-container/index.js"
import { Toolbar } from "@cirrus/ui-kit/src/components/atoms/toolbar/index.js"
import { useTableContext } from "../provider"

const StyledToolbar = styled(Toolbar)({
  marginBottom: "12px !important",
})

export const TableToolbar = () => {

  const ctx = useTableContext()

  const { toolbarButtonLeft, toolbarButtonRight } = ctx.props

  return (
    <StyledToolbar
      {...{
        contentEnd: (
          <ButtonContainer>
            {toolbarButtonRight}
          </ButtonContainer>
        ),

        contentStart: (
          <ButtonContainer>
            {toolbarButtonLeft}
          </ButtonContainer>
        ),
      }}
    />
  )
}
